import request from '../utils/request';

//获取平台唯一编码和logo

export function getUniCode(data) {
    return request({
        url: '/api/platform_data',
        method: 'post',
        data
    });
}
